import axios from "axios";
import { profile, district } from "./url";

const getAllProfile = (body) => {
  return axios.get(profile.LIST, body);
};
const getAllDistrict = () => {
  return axios.get(district.DISTRICT);
};
const addProfile = (body) => {
  return axios.post(profile.ADD, body);
};
const sendNotification = (body) => {
  return axios.post(profile.PUSH_NOTIFICATION, body);
};
const deleteProfile = (id) => {
  return axios.delete(profile.DELETE + id);
};
const getParticularProfile = (id) => {
  return axios.get(profile.PARTICULAR + id);
};
const adminGetParticularProfile = (id) => {
  return axios.get(profile.ADMIN_PARTICULAR + id);
};
const updateProfile = (id, data) => {
  return axios.put(profile.UPDATE + id, data);
};
const uploadImage = (body) => {
  return axios.post(profile.UPLOAD, body);
};

const ProfileService = {
  getAllProfile,
  deleteProfile,
  addProfile,
  getParticularProfile,
  adminGetParticularProfile,
  updateProfile,
  getAllDistrict,
  uploadImage,
  sendNotification,
};

export default ProfileService;
